module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAABHNCSVQICAgIfAhkiAAAAENJREFUKJFjYCATNDAwMOwnRiETEtuBWE0wsJ+BgeH/qCYKNTUwMKDGAyFgT3UnjSqGAWYorcjAwHCQgYEhkRjTSQIAcfUmXx0FtFkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(35).png
// module id = xRHK
// module chunks = 1